var map = {
	"./root.js": "LQyU",
	"./system.js": "dAC9"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "zgcH";


//////////////////
// WEBPACK FOOTER
// ./src/router/modules nonrecursive .js$
// module id = zgcH
// module chunks = 75